import { $i18n, $store } from '@/provider/plugin';
import { useRootStore } from '@/store/root';
import ToastEventBus from 'primevue/toasteventbus';
import {
  dateFromFormat,
  timeFromFormat,
  shortDate,
  shortYear,
} from '@/utils/time.ts';
import { getFileExtension } from '@/utils/file';

const getSettings = (type) =>
  (type && $store.getters[`${type}/getSettings`]) || {};

const filters = {
  getSetting(type, property) {
    return getSettings(type)[property];
  },

  showMessage(messageType, alias, link) {
    const summaries = {
      error: 'WX_GENERAL_ERROR_MSG',
      warn: 'WX_GENERAL_WARNING_MSG',
      info: 'WX_GENERAL_INFO_MSG',
      success: 'WX_GENERAL_SUCCESS_MSG',
    };

    ToastEventBus.emit('add', {
      group: 'customToast',
      severity: messageType,
      summary: $i18n.global.t(summaries[messageType]),
      detail: $i18n.global.t(alias),
      link,
      life: 5000,
    });
  },
  getTextAlias(text, value) {
    return { text: text && $i18n.global.t(text), value };
  },
  time: timeFromFormat,
  date: dateFromFormat,
  shortDate,
  shortYear,
  numeric: (value) => {
    const { numericFormat } = useRootStore().getUserGroups;
    if (!value) return value;
    switch (numericFormat) {
      case '#,###.##': {
        return value.toLocaleString('en-US', { minimumFractionDigits: 2 });
      }
      case '# ###,##': {
        return value.toLocaleString('fr-FR', { minimumFractionDigits: 2 });
      }
      default: {
        return value.toLocaleString('de-DE', { minimumFractionDigits: 2 });
      }
    }
  },
  // TODO: (IW-3994) Move to a helper file
  downloadFile(data, fileName) {
    const isMobile = useRootStore().device === 'mobile';
    const isPdf = getFileExtension(fileName) === 'pdf';

    if (isMobile && isPdf) {
      this.openPDFFileOnIOS(data);
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(data);

    reader.addEventListener('load', (event) => {
      const temporaryLink = document.createElement('a');
      temporaryLink.style.display = 'none';
      temporaryLink.href = event.target.result;
      temporaryLink.download = fileName;
      document.body.append(temporaryLink);
      temporaryLink.click();
      temporaryLink.remove();
    });
  },
  openPDFFileOnIOS(data) {
    const blob = new Blob([data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    window.open(url, '_blank');

    setTimeout(() => URL.revokeObjectURL(url), 10000);
  },
};

export { filters };
export default filters;
